"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyValueInlineTable = exports.useKeyMapColumns = void 0;
const react_1 = __importStar(require("react"));
const form_inline_table_field_1 = require("../../../composite/form/fields/form-inline-table-field");
const inline_table_field_cells_1 = require("../../../components/inline-table-field/inline-table-field-cells");
function useKeyMapColumns(name) {
    const columns = [
        {
            datakey: 'collectionName',
            name: 'Hodnota',
            width: 150,
            CellComponent: inline_table_field_cells_1.InlineTableFieldCells.useInlineTextFieldFactory({
                collectionDatakey: name,
            }),
        },
        {
            datakey: 'collectionPath',
            name: 'Cesta',
            width: 150,
            CellComponent: inline_table_field_cells_1.InlineTableFieldCells.useInlineTextFieldFactory({
                collectionDatakey: name,
            }),
        },
    ];
    return (0, react_1.useMemo)(() => columns, []);
}
exports.useKeyMapColumns = useKeyMapColumns;
function KeyValueInlineTable(props) {
    const columns = useKeyMapColumns('value');
    return (react_1.default.createElement(form_inline_table_field_1.FormInlineTableField, { ...props, columns: columns, showToolbar: true, initNewItem: () => ({
            collectionPath: '',
            collectionName: '',
        }), maxRows: 15, showDetailBtnCond: () => false }));
}
exports.KeyValueInlineTable = KeyValueInlineTable;
//# sourceMappingURL=key-value-inline-table.js.map